import { render, staticRenderFns } from "./HtmlCopyBtn.vue?vue&type=template&id=2cb191e6&"
import script from "./HtmlCopyBtn.vue?vue&type=script&lang=js&"
export * from "./HtmlCopyBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports